/*
 * @Author: your name
 * @Date: 2021-03-02 15:29:31
 * @LastEditTime: 2021-03-23 17:53:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\plugins\mock.js
 */
export default {
    install: (app, { router, store }) => {
        const files = import.meta.glob("@/directives/modules/*.js", { eager: true });
        Object.keys(files).forEach((key) => {
            let name = key.replace(/(\.\/|\.js)/g, "").split('/').pop();
            let method = files[key].default;
            const wrapFn = (fn) => (el, binding) => fn(el, binding, app, router, store);
            if (
                method &&
                typeof method === "object" &&
                typeof method.mounted === "function"
            ) {
                app.directive(name, {
                    mounted: (el, binding) => method.mounted(el, binding),
                    updated: method.updated
                        ? (el, binding) => method.updated(el, binding)
                        : undefined,
                    unmounted: method.unmounted
                        ? (el, binding) => method.unmounted(el, binding)
                        : undefined,
                });
            } else if (typeof method === "function") {
                const hooked = wrapFn(method);
                app.directive(name, {
                    mounted: hooked,
                    updated: hooked,
                });
            }
        });
    },
};
